import { css, CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('csc-pdp-tab')
export class CSCPdpTab extends LitElement {
  static override styles: CSSResultGroup = css`
    :host {
      display: block;
    }
  `

  @property({ type: String })
  label: string = ''

  @property({ type: Boolean })
  disabled: boolean = false

  override render() {
    return html`<slot></slot>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-pdp-tab': CSCPdpTab
  }
}
